export default __webpack_public_path__ + "static/media/C-Standard.d75c1673.png";